var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 8 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M6.519 4.633 4.162 2.276 1.805 4.633a.667.667 0 0 1-.943-.943L3.69.862c.26-.26.683-.26.943 0L7.461 3.69a.667.667 0 1 1-.942.943m0 3.057-2.357 2.357L1.805 7.69a.667.667 0 0 0-.943.943l2.828 2.829c.26.26.683.26.943 0l2.828-2.829a.667.667 0 1 0-.942-.943",
  clipRule: "evenodd"
})));
export default SvgSelectArrow;